import React from "react";

import {
    View,
    Text,
    ScrollView,
    StyleSheet,
    TouchableOpacity,
    Image,
    Dimensions,
    TextInput,
    ToastAndroid, Share
} from "react-native";

import Toast from "../Components/Toast";


import {RFValue} from "react-native-responsive-fontsize";
import {Entypo, FontAwesome, FontAwesome5, FontAwesome6, Fontisto, Ionicons} from "@expo/vector-icons";
import Config from "../../Config";
import AntDesign from "@expo/vector-icons/AntDesign";
import Feather from "@expo/vector-icons/Feather";
import MaterialCommunityIcons from "@expo/vector-icons/MaterialCommunityIcons";
import * as Linking from 'expo-linking';
import * as Clipboard from "expo-clipboard";
import AsyncStorage from "@react-native-async-storage/async-storage";
import axios from "axios";


const Ref = ({navigation}) => {

    let [referralCode, setreferralCode] = React.useState(''); // این رو می‌تونی از state یا props بگیری
    let [count_ref, setcount_ref] = React.useState(0); // این رو می‌تونی از state یا props بگیری


    React.useEffect(() => {
        getData();
    }, []);
    let getData = async () => {
        try {
            let token = await AsyncStorage.getItem('token');
            let res = await axios.get(`${Config.api}/user/home`, {'headers': {Authorization: 'Bearer ' + token}});
            if (res.data.code != 1) {
                // alert(JSON.stringify(res.data));
                // console.log(res.data.data);
                Toast(res.data.error);
            }

            setreferralCode(res.data.user.refcode);
            setcount_ref(res.data.count_ref);

        } catch (err) {
            console.log(err);
            alert('خطا')
        }
    }

    // اکشن کپی
    const copyCode = async () => {
        await Clipboard.setStringAsync(referralCode);
        ToastAndroid.show("کد دعوت کپی شد!", ToastAndroid.SHORT);

        Toast("کد دعوت کپی شد!");
    };

    // اکشن اشتراک گذاری
    const shareCode = async () => {
        try {
            const result = await Share.share({
                message: `🎁 هیمورایی عزیز!  
با استفاده از کد معرف من ${referralCode} در اپلیکیشن هیمورا ثبت نام کن و تخفیف ویژه دریافت کن!  

دانلود اپ: https://app.himoralanguagecenter.com/landing`
            });
            // می‌تونی نتیجه را بررسی کنی
            if (result.action === Share.sharedAction) {
                console.log("اشتراک گذاری انجام شد");
            } else if (result.action === Share.dismissedAction) {
                console.log("اشتراک گذاری لغو شد");
            }
        } catch (error) {
            console.log(error.message);
        }
    };

    return (
        <View style={styles.container}>
            <View style={styles.header}>
                <TouchableOpacity style={{flex: 1}}>
                    <Text style={styles.title}> معرفی به دوستان </Text>
                </TouchableOpacity>
                <TouchableOpacity
                    onPress={() => {
                        navigation.goBack()
                    }}>
                    <Ionicons style={styles.selficon} name="arrow-back" size={24} color="white"/>
                </TouchableOpacity>
            </View>
            <ScrollView style={{flex: 1}}>
                <View style={styles.content}>
                    <Text style={styles.p}>
                        🎁 هیمورایی عزیز!{'\n'}
                        با معرفی اپلیکیشن <Text style={{fontWeight: 'bold'}}>هیمورا</Text> به دوستان خود، نه تنها به
                        آن‌ها کمک می‌کنید تجربه‌ای بهتر داشته باشند، بلکه خودتان هم یک <Text style={{color: '#FFCC3E'}}>تخفیف
                        ویژه</Text> دریافت خواهید کرد!{'\n\n'}
                        همین امروز دوستانتان را دعوت کنید و از این فرصت هیجان‌انگیز بهره‌مند شوید.{'\n\n'}
                        برای دعوت دوستان، می‌توانید <Text style={{fontWeight: 'bold'}}>کد معرف خود</Text> را به دوستتان
                        بدهید یا <Text style={{fontWeight: 'bold'}}>شماره‌ای که با آن ثبت‌نام کرده‌اید</Text> را به
                        دوستانتان ارائه دهید.
                    </Text>

                    <View style={{flexDirection: 'row', marginTop: 10}}>
                        <Text style={styles.p}> افراد دعوت شده : </Text>
                        <Text style={styles.bold}>{count_ref}</Text>
                        <Text style={styles.p}>نفر</Text>
                    </View>

                    <View style={{flexDirection: 'row', marginTop: 10}}>
                        <Text style={styles.p}>کد معرف شما : </Text>
                        <Text style={styles.bold}>{referralCode}</Text>
                    </View>

                    <TouchableOpacity style={styles.button} onPress={copyCode}>
                        <Text style={styles.buttonText}>کپی کد دعوت</Text>
                    </TouchableOpacity>

                    <TouchableOpacity style={styles.button} onPress={shareCode}>
                        <Text style={styles.buttonText}>اشتراک گذاری</Text>
                    </TouchableOpacity>
                </View>
            </ScrollView>
        </View>
    );
};

const styles = StyleSheet.create({

    row: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        paddingVertical: RFValue(10),
        paddingHorizontal: RFValue(10),
        marginVertical: RFValue(20),
        borderRadius: RFValue(10),
        borderWidth: RFValue(1),
        borderColor: 'gray',
        backgroundColor: 'white',
    },
    titleitem: {
        fontSize: RFValue(13),
        fontFamily: 'yk',
        color: 'black',
        paddingVertical: RFValue(0),
    },


    content: {
        flex: 1,
        paddingHorizontal: RFValue(20),
        paddingVertical: RFValue(20),
        backgroundColor: Config.maincolor,
    },

    container: {
        flex: 1,
        backgroundColor: Config.maincolor,
    },
    header: {
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',

        backgroundColor: '#000422',
        paddingHorizontal: RFValue(20),

        shadowColor: "#000000",
        shadowOffset: {
            width: 0,
            height: 50,
        },
        shadowOpacity: 1,
        shadowRadius: 0,
        elevation: 1
    },

    bold: {
        fontFamily: 'ykb',
        fontSize: RFValue(15),
        marginVertical: RFValue(8),
        color: Config.secondcolor,
        textAlign: "justify",
        // fontWeight : "bold",
        paddingHorizontal: RFValue(6),
    },


    title: {
        fontSize: RFValue(17),
        fontFamily: 'ykb',
        color: '#FFF',
        paddingVertical: RFValue(14),

    },

    h2: {
        fontFamily: 'ykb',
        fontSize: RFValue(18),
        marginVertical: RFValue(8),
        color: "#FFF",
    },
    p: {
        fontFamily: 'ykb',
        fontSize: RFValue(13),
        marginVertical: RFValue(8),
        color: "#E4E4E4",
        textAlign: "justify",
    },

    buttonText: {
        fontFamily: 'ykb',
        fontSize: RFValue(14),
        color: Config.maincolor,
    },
    button: {
        backgroundColor: Config.secondcolor,
        textAlign: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: RFValue(20),
        borderRadius: RFValue(20),
        height: RFValue(30),

    },

})


export default Ref